// src/components/admin/EventEditDescription.js
import React from 'react';
import RichTextEditor from '../../RichTextEditor';

export default function EventEditDescription({ content, onChange, eventId }) {
  return (
    <div className="bg-neutral-800 p-8 rounded-xl space-y-4">
      <h3 className="text-lg font-semibold text-white">이벤트 정보</h3>
      <RichTextEditor
        value={content}
        onChange={onChange}
        placeholder="이벤트 설명을 입력하세요"
        entityId={eventId}
        entityType="event"
      />
    </div>
  );
}
